<script>
  import options from './DeleteGlobalProfileOverlay.options'
  export default options
</script>

<template>
  <article class="kb-delete-global-profile-overlay" aria-live="polite">
    <section class="kb-delete-global-profile-overlay__hero">
      <div class="kb-delete-global-profile-overlay__hero__title-wrapper">
        <h2 class="kb-delete-global-profile-overlay__hero__title-wrapper__title">
          {{
            getLabel('title')
          }}
        </h2>
      </div>
    </section>
    <div class="kb-delete-global-profile-overlay__hero__curve">
      <svg viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
      </svg>
    </div>
    
    <div class="kb-delete-global-profile-overlay__content-container">
      
      <div class="kb-delete-global-profile-overlay__content-text">
        {{ getLabel('description') }}
      </div>

      <div class="kb-delete-global-profile-overlay__actions">
        <div class="kb-delete-global-profile-overlay__button-wrapper">
          <a v-on:click="submit" @keydown.tab="tabTrap" data-order="first"
            class="kb-button kb-button--full-color-spot kb-delete-global-profile-overlay__kb-button--full-color-spot">
            {{ getLabel('submitButtonText') }}
          </a>
          <a v-on:click="closeOverlay" data-order="last" @keydown.tab="tabTrap" class="kb-button">
            {{ getLabel('cancelButtonText') }}
          </a>
        </div>
        <div class="kb-rich-text">
          <div class="kb-rich-text__content" v-html="privacyPolicy"></div>
        </div>
      </div>

    </div>

    <template v-if="isSubmitting">
      <div class="kb-spinner-overlay">
        <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky">
        </div>
      </div>
    </template>

  </article>
</template>
